import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import { useCallback, useState } from "react";
import classnames from "classnames";
import { useController } from "react-hook-form";
import ErrorMessage from "./ErrorMessage";
import styles from "@/styles/Form.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function MultipleCheckboxField(_ref) {
  var options = _ref.options,
      control = _ref.control,
      name = _ref.name,
      error = _ref.error,
      title = _ref.title,
      help = _ref.help,
      required = _ref.required,
      row = _ref.row,
      _ref$defaultValue = _ref.defaultValue,
      defaultValue = _ref$defaultValue === void 0 ? [] : _ref$defaultValue;

  var _useController = useController({
    control: control,
    name: name,
    defaultValue: defaultValue
  }),
      field = _useController.field;

  var _useState = useState(defaultValue),
      value = _useState[0],
      setValue = _useState[1];

  var handleChange = useCallback(function (e) {
    var newValue = function () {
      if (e.target.checked) {
        return [].concat(_toConsumableArray(value), [e.target.value]);
      } else {
        return value.filter(function (v) {
          return v !== e.target.value;
        });
      }
    }();

    field.onChange(newValue);
    setValue(newValue);
  }, [value]);
  return /*#__PURE__*/_jsxs("fieldset", {
    className: styles.inputField,
    children: [title && /*#__PURE__*/_jsx("legend", {
      className: classnames(styles.formTitle, _defineProperty({}, styles.required, required)),
      children: title
    }), help && /*#__PURE__*/_jsx("span", {
      className: styles.help,
      children: help
    }), /*#__PURE__*/_jsx("div", {
      className: classnames(styles.multipleCheckbox, _defineProperty({}, styles.row, row)),
      children: options.map(function (option, index) {
        return /*#__PURE__*/_jsxs("div", {
          className: classnames(styles.checkbox),
          children: [/*#__PURE__*/_jsx("input", {
            id: "checkbox-".concat(name, "-").concat(index),
            type: "checkbox",
            value: option.value,
            onChange: handleChange,
            onBlur: field.onBlur
          }), /*#__PURE__*/_jsx("label", {
            htmlFor: "checkbox-".concat(name, "-").concat(index),
            className: styles.label,
            tabIndex: "0",
            onBlur: field.onBlur,
            children: /*#__PURE__*/_jsx("span", {
              children: option.label
            })
          })]
        }, "checkbox-".concat(name, "-").concat(index));
      })
    }), error && /*#__PURE__*/_jsx(ErrorMessage, {
      msg: error
    })]
  });
}